var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg7(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.161 2.559H12.982L10.6 8.363h33.179l2.382-5.804Zm-3.583 8.714H9.4L7 17.076h33.179l2.4-5.803Zm-3.583 8.697H5.816l-2.4 5.82h33.179l2.4-5.82Z",
    fill: "#0AF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.941 43.995 3.84 32.102h2.877l1.592 5.166c.462 1.533.705 2.343 1.013 3.628.278-1.23.461-1.814.976-3.547l1.593-5.247h2.752l-4.161 11.893H7.94Zm11.011 0v-9.9h-3.765v-1.998h10.466l-.746 1.997H21.57v9.895h-2.617v.006Zm10.105-7.142h1.468c.45 0 .675 0 .9-.06.61-.167.995-.658.995-1.338 0-.805-.409-1.15-.995-1.318-.248-.06-.497-.08-.994-.08h-1.374v2.796Zm.024 2.056v3.126h1.805c.54 0 1.036-.043 1.397-.35.362-.309.521-.703.521-1.216 0-.388-.112-.76-.337-1.03-.385-.432-.858-.535-1.67-.535h-1.716v.005Zm4.173-1.252v.043a4.68 4.68 0 0 1 1.22.637c.77.578 1.107 1.339 1.107 2.327 0 1.625-.947 2.796-2.504 3.169-.474.124-.971.167-1.895.167h-4.718V32.102h4.174c.858 0 1.444.043 1.965.168 1.51.372 2.504 1.317 2.504 2.817 0 .805-.313 1.48-.834 1.933a3.35 3.35 0 0 1-1.019.637Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg7);
export default __webpack_public_path__ + "static/media/7.60ce3fb474ff8a2a7514a4efcf1cc2ec.svg";
export { ForwardRef as ReactComponent };